import { render, staticRenderFns } from "./extDogDoor.vue?vue&type=template&id=5d23d689&scoped=true"
import script from "./extDogDoor.vue?vue&type=script&lang=js"
export * from "./extDogDoor.vue?vue&type=script&lang=js"
import style0 from "./extDogDoor.vue?vue&type=style&index=0&id=5d23d689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23d689",
  null
  
)

export default component.exports